import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';
/* replace-start */
import './index.less';
/* replace-end */
class Feature26 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getHtml(data) {
      return data.map((item, index) => {
        return (
          <div {...item} key={item.name + index}>
            <div {...item.title}>
              {
                item.title.children.map(getChildrenToRender)
              }
            </div>
            <div {...item.block}>
              {
                item.block.children.map(getChildrenToRender)
              }
            </div>
          </div>
        );
      });
    }

    return (
      <OverPack {...tagProps} {...dataSource.wrapper}>
        <div {...dataSource.bg}>
          <img src={dataSource.bg.children} alt="" />
        </div>
        <div {...dataSource.page}>
          <div {...dataSource.content}>
            <div {...dataSource.content.title}>
              {
                dataSource.content.title.children.map(getChildrenToRender)
              }
            </div>
            <div {...dataSource.content.box}>
              {
              getHtml(dataSource.content.box.children)
            }
            </div>
          </div>
        </div>
      </OverPack>
    );
  }
}
export default Feature26;
